module.exports = __webpack_public_path__ + "static/china-smartkids.6b0ebb89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/china-smartkids.jpg
// module id = 843
// module chunks = 135882870033682